import { Column } from '@ant-design/charts';
import { data } from 'data/bar';
import { useTheme } from 'contexts/theme';
import { GREEN, ORANGE, RED } from 'utils/colors';

export default function YOY() {
  const { dark } = useTheme();
  const color = dark ? 'white' : 'black';

  const config: any = {
    data: data,
    isGroup: true,
    height: 200,
    xField: 'label',
    yField: 'value',
    seriesField: 'type',
    color: [RED, GREEN, ORANGE],
    legend: {
      itemName: {
        style: {
          fill: color
        }
      }
    },
    xAxis: {
      grid: {
        line: {
          style: {
            stroke: color,
            lineDash: [4, 5],
            strokeOpacity: 0.3
          }
        }
      },
      label: {
        style: {
          fill: color
        }
      }
    },
    yAxis: {
      grid: {
        line: {
          style: {
            stroke: color,
            lineDash: [4, 5],
            strokeOpacity: 0.3
          }
        }
      },
      label: {
        style: {
          fill: color
        }
      }
    }
  };
  return (
    <Column
      label={{
        position: 'top',
        style: {
          fill: 'red'
        },
        content: (item: any) => {
          if (item?.percentage) {
            return `${item.percentage}%`;
          }
        }
      }}
      {...config}
      autoFit
    />
  );
}
